// ImageUpload.js
import React, { useState, useRef } from "react";
import HeaderLogo from "../../components/Logo/HeaderLogo";
import { addDefaultImg } from "../../utils/common-methods";
//import "./ImageUpload.css";
import ImagePreview from "./ImagePreview";
const ImageUploadMulti = ({ onUpload, maxSize, validTypes }) => {
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const hiddenFileInput = useRef(null);

  // Handle multiple image selection
  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    let newImages = [...images];
    let newImagePreviews = [...imagePreviews];
    let newErrorMessage = "";

    files.forEach((file) => {
      if (!validTypes.includes(file.type)) {
        newErrorMessage = `File "${
          file.name
        }" is not a valid image type. Allowed types: ${validTypes.join(", ")}`;
      } else if (file.size > maxSize) {
        newErrorMessage = `File "${
          file.name
        }" exceeds the maximum size of ${maxSize / (1024 * 1024)}MB.`;
      } else {
        newImages.push(file);
        newImagePreviews.push(URL.createObjectURL(file));
      }
    });

    // if (newErrorMessage.trim() !== "") {
    //   newErrorMessage =
    //     newErrorMessage +
    //     ` File exceeds the maximum size of ${maxSize / (1024 * 1024)}MB.`;
    // }
    //const newImages = [...images, ...files];
    setErrorMessage(newErrorMessage);

    setImages(newImages);

    // const newImagePreviews = newImages.map((file) => URL.createObjectURL(file));
    setImagePreviews(newImagePreviews);
  };

  // Handle multiple image upload
  const handleUpload = async () => {
    if (images.length === 0) {
      alert("No images selected");
      return;
    }

    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images", image); // 'images' will be the field name on the server
    });

    try {
      await onUpload(formData);
      // alert("Images uploaded successfully!");
      setImages([]); // Reset images after successful upload
      setImagePreviews([]); // Reset preview after successful upload
    } catch (error) {
      // alert("Error uploading images");
    }
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  return (
    <section className="loginswallow">
      <div className="form-container" id="form-container">
        {/* width: "250px", */}
        <div style={{ textAlign: "center", margin: "auto auto" }}>
          <HeaderLogo></HeaderLogo>
        </div>
        <div style={{ margin: "20px", textAlign: "center" }}>
          {/* <label>
            <strong>Add or remove pictures</strong>
            <p>Add pictures to your user profile to highlight.</p>
          </label> */}
          <h5>Upload pictures</h5>
          <p>Add pictures to your profile to highlight.</p>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageChange}
            id="file-input"
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />

          {errorMessage && (
            <div className="text-danger mt-3">{errorMessage}</div>
          )}
          <div className="img-ds2" style={{ marginTop: "10px" }}>
            {imagePreviews.map((preview, index) => (
              <div
                className="img-ds1"
                style={{ textAlign: "center" }}
                key={index}
              >
                <img
                  src={preview}
                  width="100%"
                  height="100%"
                  alt="noimage"
                  onError={addDefaultImg}
                ></img>
                {/* <ImagePreview
                  src={preview}
                  width="100%"
                  height="100%"
                  style={{
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    BorderAll: "dark",
                    boxshadow: "green",
                    objectFit: "cover",
                    marginRight: "10px",
                    marginTop: "10px",
                  }}
                /> */}
              </div>
            ))}
          </div>
          <hr></hr>
          <div style={{ marginTop: "10px" }}>
            <button
              className="button-upload"
              onClick={handleClick}
              style={{ width: "180px", marginRight: "10px" }}
            >
              Select a file
            </button>
            {images.length > 0 && (
              <button style={{ width: "180px" }} onClick={handleUpload}>
                Upload Images
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageUploadMulti;
